/**
 * There is always a root element to carry the class: the button is the
 * component, so no configuration leaves it without one.
 */
export const resolveRendersOwnElement = (): boolean => true;
